import { render, staticRenderFns } from "./bigPreView.vue?vue&type=template&id=520baf15&scoped=true&"
import script from "./bigPreView.vue?vue&type=script&lang=js&"
export * from "./bigPreView.vue?vue&type=script&lang=js&"
import style0 from "./bigPreView.vue?vue&type=style&index=0&id=520baf15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520baf15",
  null
  
)

export default component.exports